export const TOKEN_TYPE_KEY = 'tokenType';
export const CLIENT_COOKIE_TOKEN_GETTER = 'fincrm_client_token';
export const NEW_REAL_ESTATE_PANEL_COOKIE_TOKEN_GETTER = 'auth-token';
export const TOKEN_GETTER_KEY = 'authToken';
export const ZITADEL_ID_TOKEN_KEY = 'zitadelIdToken';
export const ZITADEL_LOGIN_NAME_KEY = 'zitadelLoginName';
export const AUTH_MODE_KEY = 'auth_mode';

export enum AuthMode {
  LEGACY = 'legacy',
  ZITADEL = 'zitadel',
}

export enum TokenType {
  EXPERT = 'expert',
  CLIENT = 'client',
}
